'use client';

import { Component, createContext } from 'react';

//* Helpers
import HelperClass from '@/styles/helperClass';
import Variables from '@/styles/variables';
import Typography from '@/styles/typography';

const UIContext = createContext(null);

class UIProvider extends Component {
	//! States
	state = {
		highComponent: null,
		popupIsOpen: false,
	};

	//! Methods
	methods = {
		addHighComponent: this.addHighComponent.bind(this),
		removeHighComponent: this.removeHighComponent.bind(this),

		togglePopup: this.togglePopup.bind(this),
	};

	//! Component Did Mount
	componentDidMount() {
		this.setState({
			...this.state,
		});
	}

	//! Component Will Unmount
	componentWillUnmount() {
		document.removeEventListener('keydown', this.escKeydown, false);
	}

	//! Toggle Popup
	togglePopup() {
		this.setState({
			popupIsOpen: !this.state.popupIsOpen,
		});
	}

	//! Add High Component
	addHighComponent(component = null) {
		this.setState({
			highComponent: component,
		});
	}

	//! Update High Component
	updateHighComponentProps(props) {
		const Comp = this.state.component;
		Comp.props = props;

		this.setState({
			highComponent: Comp,
		});
	}

	//! Remove High Component
	removeHighComponent() {
		this.setState({
			highComponent: null,
		});
	}

	render() {
		return (
			<UIContext.Provider value={{ ...this.state, ...this.methods }}>
				<Variables />
				<Typography popupIsOpen={this.state.popupIsOpen} />
				<HelperClass />

				{this.props.children}
			</UIContext.Provider>
		);
	}
}

export default UIProvider;
export const UIConsumer = UIContext.Consumer;
